import * as routeNames from '@/shared/router/route-names'

export default [
  {
    path: '/',
    redirect: 'billRequest'
  },
  {
    path: '/dailyInspection',
    name: routeNames.DAILYINSPECTION,
    component: () => import('@/views/apps/inspection/dailyInspection')
  },
  {
    path: '/renovationInspection',
    name: routeNames.RENOVATIONINSPECTION,
    component: () => import('@/views/apps/inspection/renovationInspection')
  }
]
